import PageHeader from "../../Components/BaseComponents/pageHeader";

export default function Farms() {  
  return (
    <PageHeader topHeader='Farms' subHeader='Overview'/>
  )
}